import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import { useSelector } from "react-redux";
import {
  GetUnderwritingOutputByClientId,
  UnderwritingOutputReport,
} from "../../../../api/User/ACG/UnderwritngOutputApi";
import Fontstyling from "../../../../components/common/comman";
import toastFile from "../../../../Service/ToastFile";
import { Spinner } from "react-bootstrap";

const UnderwritingOutput = () => {
  const user = useSelector((state) => state.userDetails.value);
  const client = useSelector((state) => state.clientData.value);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isGenerate, setisGenerate] = useState(false);

  const overrideColumn = [
    {
      title: "Client ID",
      field: "client_ID",
    },
    {
      title: "Client Name",
      field: "client_NM",
    },
    {
      title: "Report Index",
      field: "report_Index",
    },
    {
      title: "Element Name",
      field: "element_Name",
    },
    {
      title: "Data",
      field: "data",
    },
    {
      title: "Report Date",
      field: "reportDate",
    },
  ];

  useEffect(() => {
    getData();
  }, [client?.clientID]);

  const getData = () => {
    setIsLoading(true);
    GetUnderwritingOutputByClientId(client?.clientID)
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => console.log({ err }))
      .finally((res) => setIsLoading(false));
  };

  const handleclick = () => {
    if (
      client === null ||
      client?.clientID === null ||
      client?.clientID === 0
    ) {
      toastFile("Select Client");
      return;
    }
    setisGenerate(true);
    UnderwritingOutputReport(client?.clientID, user.UD_id).then((res) => {
      if (res.data.success) {
        toastFile("new");
        getData();
      } else {
        toastFile("something wrong");
      }
    }).finally(res=>setisGenerate(false))
  };

  return (
    <div>
      <div className="text-end">
        <button style={Fontstyling.addnewbutton} onClick={handleclick} disabled={isGenerate}>
          {isGenerate ? (
            <div className="d-flex justify-content-center align-items-center">
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="false"
                style={{ marginRight: "5px" }}
              />
              <span>Generate Underwriting Output Report</span>
            </div>
          ) : (
            "Generate Underwriting Output Report"
          )}
        </button>
      </div>
      <CustomMaterialTable
        isExport={false}
        overrideColumn={overrideColumn}
        data={data}
        isLoading={isLoading}
      />
    </div>
  );
};

export default UnderwritingOutput;
